export default "__VITE_ASSET__CzyE0q_c__"